import { DetalheFornecedorUtils } from 'px-components';

export const buildFornecedor = (data, fornecedor) => {
  const { detalhesFornecedores } = data;
  const detalhe = DetalheFornecedorUtils.getDetalhe(fornecedor.id, detalhesFornecedores);

  return {
    ...fornecedor,
    codigoInterno: detalhe.codigoInterno,
    pessoa: {
      ...fornecedor.pessoa,
      nome: detalhe.nome || fornecedor.pessoa.nome,
    },
  };
};

export const buildFornecedorCompra = (data) => {
  if (!data.fornecedor) {
    return null;
  }
  return {
    ...data.fornecedor,
    codigoInterno: data.codigoInternoFornecedor || null,
    pessoa: {
      ...data.fornecedor.pessoa,
      nome: data.nomeInternoFornecedor || data.fornecedor.pessoa.nome,
    },
  };
};

export const buildTransportadoraCompra = (data) => {
  if (!data.transportadora) {
    return null;
  }
  return {
    ...data.transportadora,
    codigoInterno: data.codigoInternoTransportadora || null,
    pessoa: {
      ...data.transportadora.pessoa,
      nome: data.nomeInternoTransportadora || data.transportadora.pessoa.nome,
    },
  };
};

export default {
  buildFornecedor,
};
